import React, { VFC } from 'react'

import {
  PersonalisationModalLayout,
} from '@Components/Personalization/Layout/PersonalizationModalLayout'
import { PersonalisationModal } from '@Components/Personalization/Modals/Shared'

const info = {
  title: 'products:LASER_ENGRAVING_OPTIONS',
  list: [
    'products:NO_DELAY_ON_ENGRAVED_PRODUCTS',
    'products:SAME_FONT_AND_TEXT_SIZE_ADJUSTMENT_INFO',
    'products:ENGRAVED_PRODUCTS_ARE_NOT_RETURNABLE',
  ],
}
export const EngravingModal: VFC<PersonalisationModal> = props => (
  <PersonalisationModalLayout
    info={info}
    type="engrave"
    {...props}
  />
)

